import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDateLocale'
})
export class FormatDateLocalePipe implements PipeTransform {
  transform(
    value: any
  ): string {
    const date = new Date(value);

    if (isNaN(date.getTime())) {
      return 'Invalid date';
    }

    return new Intl.DateTimeFormat('en-IL', {
        dateStyle: "short",
        timeStyle: "short",
      }).format(date);
  }
}
